import { render, staticRenderFns } from "./VistaGaleria.vue?vue&type=template&id=db18986e&scoped=true"
import script from "./VistaGaleria.vue?vue&type=script&lang=js"
export * from "./VistaGaleria.vue?vue&type=script&lang=js"
import style0 from "./VistaGaleria.vue?vue&type=style&index=0&id=db18986e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db18986e",
  null
  
)

export default component.exports